import { wrapCall } from '../utils/serviceUtils';
import { api } from '../services';
import * as types from '../constants/actionTypes';

export const answerCorrelation = (dsaCorrelation, answer) => {
  return wrapCall(
    api.post(
      '/dsacorrelation/' + dsaCorrelation.id,
      { answer }
    ),
    types.ANSWER_CORRELATION,
    {
      dsaCorrelationId: dsaCorrelation.id,
      answer
    }
  );
};

export const batchAnswerCorrelations = (yes, no, clear) => {

  return wrapCall(
    api.put(
      '/dsacorrelation',
      { yes, no, clear }
    ),
    'batch_answer_correlations',
    { yes, no, clear }
  );
};




// WEBPACK FOOTER //
// ./src/actions/correlationActions.js